import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import * as Sentry from '@sentry/react';
import qs from 'qs';
import { getIncomeSource } from '@/utils/vip';
import CODE from '../constants/code';
import { CLIENT_ID, PREVIEW_MODE } from '../constants';
import { getUrlParam, getChannel } from '.';

// 全局的 axios 默认值
axios.defaults.baseURL = '';
axios.defaults.withCredentials = true; // 只有/user/token接口需要配置
axios.defaults.headers.post['Content-Type'] = 'application/json';

const isPcLogin =
  getIncomeSource() !== 'MTXX-WEB' && getUrlParam('client_referer') === 'client_login';
// 不添加Client-OID/Client-OGroupID的接口列表
const whitelist: string[] = [
  '/user/redirect_url',
  '/user/token',
  '/configure/audit_version',
  '/subs/product',
  '/payment/cashier/pay.json',
];

// 接口公共参数
export const commonParams = {
  client_id: CLIENT_ID,
  preview_mode: PREVIEW_MODE,
  channel: getChannel(),
} as Record<string, string | number>;

const UNAUTHORIZED = CODE.UNAUTHORIZED;
console.log('UNAUTHORIZED: ', UNAUTHORIZED);

// 添加请求拦截器
axios.interceptors.request.use(
  (config: any) => {
    if (!config?.internalFetch) {
      commonParams.gid = window.localStorage.getItem('gid') || '';
    }
    // 在发送请求之前做些什么
    if (config.method === 'post') {
      if (config.headers['Content-Type'] === 'application/json') {
        const data = Object.assign({}, commonParams, config.data || {});
        config.data = qs.stringify(data);
      }
    } else if (config.method === 'get') {
      config.params = Object.assign({}, commonParams, config.params || {});
    }
    return config;
  },
  (error: any) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  async (response: any) => {
    if (!['get', 'post'].includes(response?.config?.method || '')) return response;

    // const config: RequestConfig = response.config;
    // const hideErrorToast = config.hideErrorToast;
    // console.log('hideErrorToast: ', hideErrorToast);

    // 只针对get/post请求方式的返回做处理
    const code = response.data.error_code;
    // const msg = response.data.msg;
    // console.log('msg: ', msg);

    if (code !== CODE.OK) {
      // if (!hideErrorToast) message.error(msg || '请求出错，请稍后再试');
    }

    // 对响应数据做点什么
    return response;
  },
  (error: any) => {
    const url = error?.response?.config?.url || '';
    // 业务侧的接口服务端校验异常都返回400
    if (!url.includes('webapi.designkit.cn')) {
      Sentry.captureException(error);
    }

    return error?.response;
  }
);

/**
 * 拓展配置项
 */
interface CustomizeConfigs {
  // 默认展示错误提示
  hideErrorToast?: boolean;
  // 内部node层发起的请求
  internalFetch?: boolean;
  access_token?: string;
}

interface RequestConfig extends AxiosRequestConfig, CustomizeConfigs {}

export default function request<T>(api: string, config?: RequestConfig): Promise<AxiosResponse<T>> {
  const requestOptions: RequestConfig = Object.assign(
    {
      hideErrorToast: false,
    },
    {
      url: api,
    },
    config
  );

  if (!requestOptions.headers) {
    requestOptions.headers = {};
  }

  requestOptions.headers.access_token =
    (!config?.internalFetch && window.localStorage.getItem('access_token')) || '';

  if (!isPcLogin && !whitelist.find((key) => api.includes(key))) {
    requestOptions.headers['Client-OID'] = getUrlParam('oid');
    requestOptions.headers['Client-OGroupID'] = getUrlParam('groupId');
  }

  return axios(requestOptions);
}
